/* @flow */
import { makeCancelable } from 'lib/promise';
import React from 'react';
import { Container } from 'flux/utils';
import Activity from 'entities/Activity';
import ActivityActions from 'payments/actions/ActivityActions';
import ActivityStore from 'payments/stores/ActivityStore';
import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import ActivitiesClass from 'payments/components/ActivitiesClass.jsx';
import ActivitiesTabNux from 'payments/components/ActivitiesTabNux.jsx';
import WalletTabLoader from 'payments/components/WalletTabLoader.jsx';
import type {CancelablePromise} from 'lib/promise' // eslint-disable-line

/* Cannot manage activities when
 * the context group is defined and the
 * current user is not owner of said group.
 */
function canManageActivitiesForGroup(group: Group): boolean {
  const isRootGroup: boolean = group.isRoot();
  const isOwnedByUser: boolean = group.isOwnedByUser(CurrentUser.getUserId());

  return (
    CurrentUser.getUser().canCreateActivity() && (
      isRootGroup ||
      isOwnedByUser
    )
  );
}

type Props = {
  group: Group,
};

type State = {
  errored: boolean,
  loading: boolean,
  activities: Activity[],
};

class ActivitiesClassContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [ActivityStore, CurrentUser];
  }

  static calculateState(state, props) {
    return {
      errored: state ? state.errored : false,
      loading: state ? state.loading : true,
      activities: ActivityStore.getActivityForGroup(props.group),
    };
  }

  componentDidMount() {
    const onError = (reason) => {
      if (reason && reason.isCanceled) {
        return;
      }

      this.setState({ errored: true });
      throw reason;
    };

    this.cancelable = makeCancelable(ActivityActions.load());
    this.cancelable.promise.then(() => this.setState({ loading: false })).catch(onError);
  }

  componentWillUnmount() {
    this.cancelable.cancel();
  }

  cancelable: CancelablePromise;

  render() {
    const { activities } = this.state;
    const { group } = this.props;

    if (this.state.errored) {
      return <span>An error happened</span>;
    }

    const canManage: boolean = canManageActivitiesForGroup(group);

    if (activities.length > 0) {
      return <ActivitiesClass activities={activities} canManage={canManage} />;
    }

    if (this.state.loading) {
      return <WalletTabLoader />;
    }

    return <ActivitiesTabNux group={group} canManage={canManage} />;
  }
}

export { ActivitiesClassContainer };
export default Container.create(ActivitiesClassContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/payments/containers/ActivitiesClassContainer.jsx